import React from "react";

/**
 * ErrorBoundary - catches uncaught render errors and shows a friendly
 * fallback instead of a raw stack trace. Production-safe.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMsg: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMsg: (error && error.message) || "Unknown error" };
  }

  componentDidCatch(error, info) {
    // Console for engineers, never bubbles to UI.
    // Could be wired to a backend log endpoint later.
    console.error("[BSS] Caught render error:", error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, errorMsg: "" });
  };

  handleReload = () => {
    try { window.location.reload(); } catch { /* noop */ }
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-white flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md w-full bg-white rounded-3xl shadow-xl border border-slate-100 p-8 text-center">
          <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center mx-auto mb-4">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8 text-amber-500">
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
          </div>
          <h2 className="text-xl font-bold text-slate-800 mb-2">Maaf, berlaku ralat</h2>
          <p className="text-sm text-slate-500 mb-1">
            Sesuatu yang tidak dijangka berlaku. Cuba muat semula halaman, atau kembali ke laman utama.
          </p>
          <p className="text-[11px] text-slate-300 mb-6 italic">
            Pasukan teknikal telah dimaklumkan secara automatik.
          </p>
          <div className="flex gap-2">
            <button
              onClick={this.handleReload}
              className="flex-1 py-2.5 rounded-full bg-[#0A0A0A] text-white text-sm font-semibold hover:bg-[#1a1a1a] transition"
              data-testid="error-reload-btn"
            >
              Muat Semula
            </button>
            <button
              onClick={() => { try { window.location.href = '/'; } catch { /* noop */ } }}
              className="flex-1 py-2.5 rounded-full bg-slate-100 text-slate-700 text-sm font-semibold hover:bg-slate-200 transition"
              data-testid="error-home-btn"
            >
              Laman Utama
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
